import { useEffect } from "react";

export default function Seo({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const set = (selector, attr) => {
        const el = document.querySelector(selector);
        if (el) el.setAttribute("content", description);
      };
      set('meta[name="description"]');
      set('meta[property="og:description"]');
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle && title) ogTitle.setAttribute("content", title);
    }
  }, [title, description]);
  return null;
}
